import { gsap, MotionPathPlugin } from "gsap/all";
import { useEffect } from 'react';

/**
 * For when we have an object that should follow a path. Tied to the user's scroll position.
 * @param {*} props 
 * @returns 
 */

function Key2Mobile({animate}) {
    gsap.registerPlugin(MotionPathPlugin);

    useEffect(() => {
      const pathElem = document.querySelector("#path2mobile");
      const offsetFromTop = window.innerHeight * 0.3;
      const pathBB = pathElem.getBoundingClientRect();
      const startY = pathBB.top + window.scrollY - offsetFromTop;
     // const startY = document.querySelector("#path1").offsetTop - window.innerHeight + offsetFromTop;
      const finishDistance = 900;

      const tween = gsap.to("#key2mobile", {
        duration: 50,
        paused: true,
        progress: animate ? 0.1 : 0.5,
        repeat: 0,
         motionPath: {
            path: "#path2mobile",
            align: "#path2mobile",
            alignOrigin: [0.3, 0.15],
            autoRotate: 185,
            //autoRotate: 180,
            start: 0.1
         },
         ease:"none"
      });

      let requestId = null;
     // document.addEventListener("scroll", handleScroll);
      
      if (animate) {
        document.addEventListener("scroll", handleScroll);
        tween.progress(( window.scrollY - startY) / finishDistance);
      } else {
        document.removeEventListener("scroll", handleScroll);
        tween.progress(0.5);
      }

      function handleScroll() {
        

        if (!requestId) {
          requestId = requestAnimationFrame(update);
        }
      }

      function update() {
        // Update our animation
        
        if (animate) {
          tween.progress(( window.scrollY - startY) / finishDistance);
        } else {
          tween.progress(0.5);
        }
        // Let the scroll event fire again
        requestId = null;
      }
      return () => document.removeEventListener("scroll", handleScroll);
    }, [animate]);
   return (
     <div className="pathcontainer key2mobile-container">
      <svg className="key2mobile" xmlns="http://www.w3.org/2000/svg" width="487.773" height="143.869">
         <image  href="/ReactAssets/CustomerJourney/keypaths/desktop/Key.svg" id="key2mobile" width="80" height="80" data-svg-origin="24 12" transform="matrix(-0.46016,-0.88784,0.88784,-0.46016,395.23724,345.90208)" style={{transformOrigin: '0px 0px'}}/>
         <path transform="rotate(36.1978 256.957 68.5267)" stroke="#a29064" stroke-dasharray="10 14" stroke-width="2" stroke-linejoin="round" stroke-linecap="round" fill="none" d="m298.26047,-187.00384c70.70712,104.54485 8.53767,232.22298 -138.66252,334.93887s-212.71171,296.73953 -148.53638,396.12214" data-name="Path 2" id="path2mobile"/>
      </svg>


    </div>
   );
 }
 
 export default Key2Mobile;
